import {
    HttpInterceptorFn,
    HttpRequest,
    HttpHandlerFn,
    HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { ToastService } from '@core/services/toast.service';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // ✅ Nếu token KHÔNG hợp lệ → clear session & redirect

    const token = authService.getToken();
    const isAuthRequest = req.url.includes('/login');
    const language = localStorage.getItem('app_language')?.toString() || 'vi';

    // headers mặc định cho mọi request
    const baseHeaders: Record<string, string> = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': language,
    };

    // Nếu có token và không phải login → thêm Authorization
    if (!isAuthRequest && token) {
        if (!authService.hasValidToken()) {
            authService.clearSession();
            router.navigateByUrl('/auth/sign-in');
            return throwError(() => new Error('Token expired or invalid'));
        }
        baseHeaders['Authorization'] = `Bearer ${token}`;
    }

    const authReq = req.clone({ setHeaders: baseHeaders });

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            let msg = 'Có lỗi xảy ra';

            if (error.status === 0) {
                msg = 'Không thể kết nối đến server';
            } else if (error.status === 401) {
                msg = 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại';
                authService.clearSession();
                router.navigateByUrl('/auth/sign-in');
            } else if (error.status === 403) {
                msg = 'Bạn không có quyền truy cập tài nguyên này';
            } else if (error.error?.message) {
                msg = error.error.message;
            }
            return throwError(() => error);
        })
    );
};
